module.exports = __webpack_public_path__ + "static/media/squared.2a955b62.jpg";